import { render, staticRenderFns } from "./news-block.vue?vue&type=template&id=bf82faac&scoped=true&"
import script from "./news-block.vue?vue&type=script&lang=js&"
export * from "./news-block.vue?vue&type=script&lang=js&"
import style0 from "./news-block.vue?vue&type=style&index=0&id=bf82faac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf82faac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf82faac')) {
      api.createRecord('bf82faac', component.options)
    } else {
      api.reload('bf82faac', component.options)
    }
    module.hot.accept("./news-block.vue?vue&type=template&id=bf82faac&scoped=true&", function () {
      api.rerender('bf82faac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/store/news/news-block.vue"
export default component.exports